module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "change-contact"
    }
  }, [_c('modal', {
    attrs: {
      "title": "Add Contact",
      "large": ""
    },
    on: {
      "ok": function($event) {
        return _vm.ok()
      },
      "cancel": function($event) {
        return _vm.cancel()
      }
    }
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "name": "addContactForm"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('alert', {
    attrs: {
      "show": _vm.showError,
      "type": "danger"
    },
    on: {
      "update:show": function($event) {
        _vm.showError = $event
      }
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.errorString))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label pull-left",
    attrs: {
      "for": "Name"
    }
  }, [_vm._v("Given Name(s): ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.first_name),
      expression: "contact.first_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "name"
    },
    domProps: {
      "value": (_vm.contact.first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contact, "first_name", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label pull-left",
    attrs: {
      "for": "Name"
    }
  }, [_vm._v("Surname: ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.last_name),
      expression: "contact.last_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "name"
    },
    domProps: {
      "value": (_vm.contact.last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contact, "last_name", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label pull-left",
    attrs: {
      "for": "Phone"
    }
  }, [_vm._v("Phone: ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.phone_number),
      expression: "contact.phone_number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "phone"
    },
    domProps: {
      "value": (_vm.contact.phone_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contact, "phone_number", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label pull-left",
    attrs: {
      "for": "Mobile"
    }
  }, [_vm._v("Mobile: ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.mobile_number),
      expression: "contact.mobile_number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "mobile"
    },
    domProps: {
      "value": (_vm.contact.mobile_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contact, "mobile_number", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label pull-left",
    attrs: {
      "for": "Fax"
    }
  }, [_vm._v("Fax: ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.fax_number),
      expression: "contact.fax_number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "fax"
    },
    domProps: {
      "value": (_vm.contact.fax_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contact, "fax_number", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label pull-left",
    attrs: {
      "for": "Email"
    }
  }, [_vm._v("Email: ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.email),
      expression: "contact.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "email"
    },
    domProps: {
      "value": (_vm.contact.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contact, "email", $event.target.value)
      }
    }
  })])])])])], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a646e6c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/add_contact.vue
// module id = 1019
// module chunks = 0